import { 
  Component, 
  OnInit,
  OnChanges,
  OnDestroy,
  Input,
  SimpleChanges,
  Output,
  EventEmitter,
  ViewChild,
  Inject,
  forwardRef
} from '@angular/core';

import { 
  FormGroup,
  Validators 
} from '@angular/forms';

import { MatLegacySelectChange as MatSelectChange } from '@angular/material/legacy-select';
import { isEqual, isNil, isEmpty } from 'lodash-es';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { DatexFormControl } from './models/datex-form-control';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  SeparatorModel,
  ButtonStyles 
} from './models/control';
import { Styles, ControlContainerStyles } from './models/style';
import { FieldModel } from './models/field';
import { ToolModel } from './models/tool';
import { TabItemModel, TabGroupModel } from './models/tab';
import { WidgetModel } from './models/widget';
import { FieldsetModel } from './models/fieldset';

import { SharedModule } from './shared.module';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { Invoices_ShellService, EModalSize, EToasterType, EToasterPosition } from './Invoices.shell.service';
import { Invoices_OperationService } from './Invoices.operation.service';
import { Invoices_DatasourceService } from './Invoices.datasource.index';
import { Invoices_FlowService } from './Invoices.flow.index';
import { Invoices_ReportService } from './Invoices.report.index';
import { Invoices_LocalizationService } from './Invoices.localization.service';
import { Language } from './localization.service';
import { $types } from './Invoices.types'

import { Invoices_invoicing_instructions_gridComponent } from './Invoices.invoicing_instructions_grid.component';
import { Invoices_invoicing_logs_gridComponent } from './Invoices.invoicing_logs_grid.component';
import { Invoices_invoicing_transactions_gridComponent } from './Invoices.invoicing_transactions_grid.component';
import { Invoices_invoicing_options_gridComponent } from './Invoices.invoicing_options_grid.component';
import { Invoices_invoicing_instructions_dd_singleComponent } from './Invoices.invoicing_instructions_dd_single.component'
import { Invoices_invoicing_projects_dd_singleComponent } from './Invoices.invoicing_projects_dd_single.component'

@Component({
  standalone: true,
  imports: [
    SharedModule,
    forwardRef(() => Invoices_invoicing_instructions_gridComponent),
    forwardRef(() => Invoices_invoicing_logs_gridComponent),
    forwardRef(() => Invoices_invoicing_transactions_gridComponent),
    forwardRef(() => Invoices_invoicing_options_gridComponent),
    forwardRef(() => Invoices_invoicing_instructions_dd_singleComponent),
    forwardRef(() => Invoices_invoicing_projects_dd_singleComponent),
  ],
  selector: 'Invoices-invoicing_instructions_hub',
  templateUrl: './Invoices.invoicing_instructions_hub.component.html'
})
export class Invoices_invoicing_instructions_hubComponent implements OnInit, OnDestroy, OnChanges {

  inParams: { projectId?: number, billingContractId?: number } = { projectId: null, billingContractId: null };
  //#region Inputs
  @Input('projectId') set $inParams_projectId(v: number) {
    this.inParams.projectId = v;
  }
  get $inParams_projectId(): number {
    return this.inParams.projectId;
  }
  @Input('billingContractId') set $inParams_billingContractId(v: number) {
    this.inParams.billingContractId = v;
  }
  get $inParams_billingContractId(): number {
    return this.inParams.billingContractId;
  }
  //#endregion Inputs

  @Input() showInDialog: boolean = false; 
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();  
  //#endregion Outputs
  hasToolbar: boolean = true;



  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  //#region Variables
  vars: { projectIds?: number[] } = { };
  //#endregion
  formGroup: FormGroup = new FormGroup({
    invoicing_instructions: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
    invoicing_projects: new DatexFormControl(null, { validators: [  ], updateOn: 'blur' }),
  });
  
  toolbar = {
  };

  actionbar = {
  };

 filters = {
    invoicing_instructions: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['invoicing_instructions'] as DatexFormControl, 
  ESelectBoxType.dropdown, null,
  false, 
  '')
, new ControlContainerStyles(null, null), '', false)
,
    invoicing_instruction_execute: new FieldModel(new ButtonModel('', new ButtonStyles(['primary'], null), false, 'Execute instruction', 'ms-Icon ms-Icon--ProcessingRun')
, new ControlContainerStyles(null, null), '', false)
,
    execute_invoice_line_creation: new FieldModel(new ButtonModel('', new ButtonStyles(['primary'], null), false, 'Execute invoice line creation', 'ms-Icon ms-Icon--ProcessingRun')
, new ControlContainerStyles(null, null), '', false)
,
    invoicing_projects: new FieldModel(new SelectBoxModel(
  this.formGroup.controls['invoicing_projects'] as DatexFormControl, 
  null, null,
  false, 
  '')
, new ControlContainerStyles(null, null), 'Projects', false)
,
  };


  filtersets = {
  invoicing_instructions: new FieldsetModel('Invoicing instructions', false, false, true),
  invoicing_projects: new FieldsetModel('Projects', false, false, true),
};

    rootTabGroup = new TabGroupModel();
  
    subTabGroups = {
    };
  
    onTabSelected(event: MatSelectChange) {
      event.value.activate();
    }
  
    tabs = {
      invoicing_instructions: new TabItemModel(
        this.rootTabGroup, 
        'Instructions', 
        ),
      invoicing_logs: new TabItemModel(
        this.rootTabGroup, 
        'Logs', 
        ),
      invoicing_transactions: new TabItemModel(
        this.rootTabGroup, 
        'Transactions', 
        ),
      options: new TabItemModel(
        this.rootTabGroup, 
        'Options', 
        ),
    };
  
    //#region tabs inParams
    get $tabs_invoicing_instructions_invoicing_instructions_grid_inParams_billingContractId(): number {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.inParams.billingContractId;
      
      return expr;
    }
  
    get $tabs_invoicing_instructions_invoicing_instructions_grid_inParams_projectId(): number {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.invoicing_projects.control.value;
      
      return expr;
    }
  
    get $tabs_invoicing_logs_invoicing_logs_grid_inParams_billingContractId(): number {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.inParams.billingContractId;
      
      return expr;
    }
  
    get $tabs_invoicing_logs_invoicing_logs_grid_inParams_projectId(): number {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.invoicing_projects.control.value;
      
      return expr;
    }
  
    get $tabs_invoicing_transactions_invoicing_transactions_grid_inParams_billingContractId(): number {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.inParams.billingContractId;
      
      return expr;
    }
  
    get $tabs_invoicing_transactions_invoicing_transactions_grid_inParams_projectId(): number {
      const $hub = this;
      const $utils = this.utils;
      const expr = $hub.filters.invoicing_projects.control.value;
      
      return expr;
    }
  
    //#endregion tabs inParams
  
    //#region tabs children
      @ViewChild('$tabs_invoicing_instructions', { read: Invoices_invoicing_instructions_gridComponent }) $tabs_invoicing_instructions: Invoices_invoicing_instructions_gridComponent;
      @ViewChild('$tabs_invoicing_logs', { read: Invoices_invoicing_logs_gridComponent }) $tabs_invoicing_logs: Invoices_invoicing_logs_gridComponent;
      @ViewChild('$tabs_invoicing_transactions', { read: Invoices_invoicing_transactions_gridComponent }) $tabs_invoicing_transactions: Invoices_invoicing_transactions_gridComponent;
      @ViewChild('$tabs_options', { read: Invoices_invoicing_options_gridComponent }) $tabs_options: Invoices_invoicing_options_gridComponent;
    //#endregion tabs children

  //#region filters inParams
  get $fields_invoicing_instructions_selector_inParams_billingContractId(): number {
    const $hub = this;
    const $utils = this.utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    const expr = $hub.inParams.billingContractId;
    
    return expr;
  }



  cacheValueFor_$fields_invoicing_projects_selector_inParams_projectIds: number[];
  get $fields_invoicing_projects_selector_inParams_projectIds(): number[] {
    const $hub = this;
    const $utils = this.utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    const expr = $hub.vars.projectIds;
    
    if(!isEqual(this.cacheValueFor_$fields_invoicing_projects_selector_inParams_projectIds, expr)) {
      this.cacheValueFor_$fields_invoicing_projects_selector_inParams_projectIds = expr;
    }
    return this.cacheValueFor_$fields_invoicing_projects_selector_inParams_projectIds;
  }



  //#endregion filters inParams

  get hubTitle(): string {
    const $hub = this;
    const $utils = this.utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    return `Invoicing Instructions Hub`;
  }

  get hubDescription(): string {
    const $hub = this;
    const $utils = this.utils;
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //const $l10n = this.localization;
    return `This is the hub for invoicing instructions.`;
  }

  constructor(
  private utils: UtilsService,
  private settings: SettingsValuesService,
  private shell: Invoices_ShellService,
  private datasources: Invoices_DatasourceService,
  private flows: Invoices_FlowService,
  private reports: Invoices_ReportService,
  private localization: Invoices_LocalizationService,
  private operations: Invoices_OperationService,
  ) { 
    this.$subscribeFormControlValueChanges();
    this.hasToolbar = !isEmpty(this.toolbar);

    //#region tabs tab init
    this.rootTabGroup.tabs = [
      this.tabs.invoicing_instructions,
      this.tabs.invoicing_logs,
      this.tabs.invoicing_transactions,
      this.tabs.options,
    ]; 
    //#endregion tabs tab init
  }

  ngOnInit(): void {
    this.$init();
  }
  
  private $isFirstNgOnChanges = true;
  ngOnChanges(changes: SimpleChanges): void {
    if (this.$isFirstNgOnChanges) {
      this.$isFirstNgOnChanges = false;
    } else {
      this.$init();
    }
  }

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }



  initialized = false;

  async $init() {
    this.title = 'Invoicing Instructions Hub';
    
    const $hub = this;
    const $utils = this.utils;


    await this.on_init();

    this.initialized = true;
  }

  private $subscribeFormControlValueChanges() {
  }
  close() {
    this.$finish.emit();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = Promise.resolve(null);
    
    // children
    if (skipChildren === false) {
      this.$refreshChildren(childToSkip);
    }

    return result;
  }

  $refreshChildren(childToSkip: string) {
    //#region tabs children
    if (childToSkip !== '$tabs_invoicing_instructions') {
      if (!isNil(this.$tabs_invoicing_instructions) && !this.tabs.invoicing_instructions.hidden) {
        this.$tabs_invoicing_instructions.refresh(true, false, null);
      }
    }
    if (childToSkip !== '$tabs_invoicing_logs') {
      if (!isNil(this.$tabs_invoicing_logs) && !this.tabs.invoicing_logs.hidden) {
        this.$tabs_invoicing_logs.refresh(true, false, null);
      }
    }
    if (childToSkip !== '$tabs_invoicing_transactions') {
      if (!isNil(this.$tabs_invoicing_transactions) && !this.tabs.invoicing_transactions.hidden) {
        this.$tabs_invoicing_transactions.refresh(true, false, null);
      }
    }
    if (childToSkip !== '$tabs_options') {
      if (!isNil(this.$tabs_options) && !this.tabs.options.hidden) {
        this.$tabs_options.refresh(true, false, null);
      }
    }
    //#endregion tabs children
  }

  openImageViewer(imageSource: string) {
    this.shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_init(event = null) {
    return this.on_initInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_initInternal(
    $hub: Invoices_invoicing_instructions_hubComponent,
  
    $shell: Invoices_ShellService,
    $datasources: Invoices_DatasourceService,
    $flows: Invoices_FlowService,
    $reports: Invoices_ReportService,
    $settings: SettingsValuesService,
    $operations: Invoices_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: Invoices_LocalizationService,
    $event: any
  ) {
  //O.Arias - 05/01/2024
  
  if (!(await $operations.Invoices.Enable_AutoInvoicing.isAuthorized())) {
      await $shell.Invoices.openErrorDialog("Not authorized!", "You have not been authorized to view the auto invoicing components.");
      $hub.close();
  }
  
  if (await $operations.Invoices.Enable_AutoInvoicing_ManualExecution.isAuthorized()) {
      $hub.filtersets.invoicing_instructions.hidden = false;
  } else {
      $hub.filtersets.invoicing_instructions.hidden = true;
  }
  
  const projectId = $hub.inParams.projectId;
  
  if ($utils.isDefined(projectId)) {
  
      $hub.vars.projectIds = [projectId];
      $hub.filters.invoicing_projects.control.value = projectId;
      $hub.filtersets.invoicing_projects.hidden = true;
  
      if (projectId === 0) {
          $hub.filters.invoicing_projects.control.value = null;
      } else {
          $hub.tabs.options.hidden = true;
      }
  
  } else {
  
      let projectIds: number[] = [];
  
      projectIds.push(0);
  
      const instructions = (await $flows.Invoices.invoicing_instruction({
          action: "Read"
      })).payload;
  
      if ($utils.isDefined(instructions)) {
          projectIds.push(...instructions.map(i => i.projectId))
          projectIds = projectIds.filter((value, index, array) => array.indexOf(value) === index); //Distinct
      }
  
      $hub.vars.projectIds = projectIds;
  }
  
  if ($utils.isDefined($hub.inParams.billingContractId)) {
      $hub.filtersets.invoicing_projects.hidden = true;
  }
  }
  on_instruction_execute(event = null) {
    return this.on_instruction_executeInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_instruction_executeInternal(
    $hub: Invoices_invoicing_instructions_hubComponent,
  
    $shell: Invoices_ShellService,
    $datasources: Invoices_DatasourceService,
    $flows: Invoices_FlowService,
    $reports: Invoices_ReportService,
    $settings: SettingsValuesService,
    $operations: Invoices_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: Invoices_LocalizationService,
    $event: any
  ) {
  //O.Arias - 04/17/2024
  
  let instructionId: string = $hub.filters.invoicing_instructions.control.value;
  let instructionName: string = $hub.filters.invoicing_instructions.control.displayText;
  
  try {
  
      let results = (await $flows.Invoices.invoicing_main({
          instructionId: instructionId,
          output: true
      }));
  
      if ($utils.isDefined(results)) {
          $shell.Invoices.openview_json_payloadDialog({ payload: results, title: `${instructionName}` })
      } else {
          $shell.Invoices.openInfoDialog(`Nothing returned!`, `The ${instructionName} did not return a payload.`)
      }
  
      $hub.refresh();
  
  } catch (error) {
  
      let targetError = error;
      while ($utils.isDefined(targetError?.error)) {
          targetError = targetError.error;
      };
  
      if (!$utils.isDefined(targetError?.message)) {
          targetError = { "message": `Uncaught exception! ${JSON.stringify(targetError)}` }
      };
  
      await log_add({
          level: 2,
          process: `on_instruction_execute`,
          notes: JSON.stringify({ error: targetError.message })
      });
  };
  
  const log_schema = (await $flows.Invoices.invoicing_log({ action: "" })).payload;
  async function log_add(input: typeof log_schema[0]) {
      await $flows.Invoices.invoicing_log({ action: "Write", payload: input });
  };
  }
  on_invoice_lines_create_execute(event = null) {
    return this.on_invoice_lines_create_executeInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_invoice_lines_create_executeInternal(
    $hub: Invoices_invoicing_instructions_hubComponent,
  
    $shell: Invoices_ShellService,
    $datasources: Invoices_DatasourceService,
    $flows: Invoices_FlowService,
    $reports: Invoices_ReportService,
    $settings: SettingsValuesService,
    $operations: Invoices_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: Invoices_LocalizationService,
    $event: any
  ) {
  //O.Arias - 04/22/2024
  
  try {
  
      let results = (await $flows.Invoices.invoicing_create_invoice_lines({
          output: true
      }));
  
      if ($utils.isDefined(results)) {
          $shell.Invoices.openview_json_payloadDialog({ payload: results, title: `invoicing_create_invoice_lines` })
      } else {
          $shell.Invoices.openInfoDialog(`Nothing returned!`, `The invoicing_create_invoice_lines did not return a payload.`)
      }
  
      $hub.refresh();
  
  } catch (error) {
  
      let targetError = error;
      while ($utils.isDefined(targetError?.error)) {
          targetError = targetError.error;
      };
  
      if (!$utils.isDefined(targetError?.message)) {
          targetError = { "message": `Uncaught exception! ${JSON.stringify(targetError)}` }
      };
  
      await log_add({
          level: 2,
          process: `on_invoice_lines_create_execute`,
          notes: JSON.stringify({ error: targetError.message })
      });
  };
  
  const log_schema = (await $flows.Invoices.invoicing_log({ action: "" })).payload;
  async function log_add(input: typeof log_schema[0]) {
      await $flows.Invoices.invoicing_log({ action: "Write", payload: input });
  };
  }
  on_instruction_option_change(event = null) {
    return this.on_instruction_option_changeInternal(
      this,
  this.shell,
      this.datasources,
      this.flows,
      this.reports,
      this.settings,
      this.operations,
      this.utils,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_instruction_option_changeInternal(
    $hub: Invoices_invoicing_instructions_hubComponent,
  
    $shell: Invoices_ShellService,
    $datasources: Invoices_DatasourceService,
    $flows: Invoices_FlowService,
    $reports: Invoices_ReportService,
    $settings: SettingsValuesService,
    $operations: Invoices_OperationService,
    $utils: UtilsService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: Invoices_LocalizationService,
    $event: any
  ) {
  //O.Arias - 04/23/2024
  
  let instruction = $hub.filters.invoicing_instructions.control.displayText;
  
  if ($utils.isDefined(instruction)) {
      $hub.filters.invoicing_instruction_execute.control.label = `Execute ${instruction}`
  } else {
      $hub.filters.invoicing_instruction_execute.control.label = `Execute instructions`
  }
  }
  //#endregion private flows
}
